<template xmlns="">
  <v-dialog dark persistent :value="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <div class="mobile-wizard-container">
      <template v-if="windowIndex !== 2">
        <div class="my-2"><v-img src="/img/roody_logo.png" height="65px" contain /></div>
        <v-progress-linear :value="progress" color="primary" height="6" class="mobile-wizard-progress"></v-progress-linear>
      </template>

      <div class="mobile-wizard-content" :style="windowIndex === 2 ? 'background: #313131' : ''" :class="{ 'fullscreen-content': windowIndex === 2 }">
        <v-fade-transition mode="out-in">
          <div v-if="windowIndex === 1" class="mobile-wizard-step" key="step1">
            <h1 class="text-h4 font-weight-bold mb-2">{{ formTitle }}</h1>
            <p class="body-1 grey--text text--lighten-1 mb-8">
              {{ formWindow === 1 ? "Wähle einen Kunden und Trainer aus." : "Bestimme die Art deines Trainingsplans." }}
            </p>
            <v-form lazy-validation dark ref="createForm" class="mt-4">
              <v-window touchless v-model="formWindow">
                <v-window-item :value="1">
                  <user-search
                    filled
                    dark
                    rounded
                    :value="form.user_id"
                    rights="tp_create"
                    class="mb-5"
                    v-if="userService.hasRight('tp_create')"
                    label="Kunde"
                    @update="updateCustomer"></user-search>
                  <user-search
                    filled
                    rounded
                    dark
                    :value="form.instructor_id"
                    rights="tp_create"
                    v-if="userService.hasRight('tp_create')"
                    label="Trainer"
                    class="mb-5"
                    instructor
                    @update="updateInstructor"></user-search>
                  <p class="red--text" v-if="noInstructorSnackbar">Bitte Trainer auswählen</p>
                </v-window-item>
                <v-window-item :value="2">
                  <v-col v-for="(split, index) in splitItems" cols="12" :key="index" class="px-0 py-1">
                    <v-card
                      @click="selectSplit(split)"
                      class="choice-card rounded-lg mb-3"
                      :class="{ 'choice-card--active': form.splits && form.splits.text === split.text }">
                      <v-card-text class="d-flex align-center">
                        <div class="flex-grow-1">
                          <div class="font-weight-bold primary--text">{{ split.text }}</div>
                          <p class="caption mb-0 grey--text text--lighten-2">{{ split.info }}</p>
                        </div>
                        <v-icon class="ml-auto" :color="form.splits && form.splits.text === split.text ? 'primary' : 'white'">
                          {{ form.splits && form.splits.text === split.text ? "mdi-check-circle" : "mdi-chevron-right" }}
                        </v-icon>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-window-item>
              </v-window>
            </v-form>
          </div>

          <div v-else-if="windowIndex === 2" key="step2-fullscreen">
            <workout-split-edit
              @next="windowIndex = 3"
              @return="windowIndex = 1"
              @save-split="addNewSplit"
              @nextStepError="handleNextStepForSplit = false"
              :handleNextStepForSplit="handleNextStepForSplit"
              :exerciseIds="workoutCreateExercises.map((exercise) => exercise._id)"
              :form="form"></workout-split-edit>
          </div>

          <div v-else-if="windowIndex === 3" class="mobile-wizard-step" key="step3">
            <WorkoutSplitOverviewAndSubmit
              @return="windowIndex = 2"
              :form="form"
              @submitPlan="createWorkoutPlan"
              @resetSubmitPlan="handleSubmitPlan = false"
              :handleSubmitPlan="handleSubmitPlan"
              @updatePlan="updateWorkoutPlan" />
          </div>
        </v-fade-transition>
      </div>

      <div class="mobile-wizard-nav" :style="windowIndex === 2 ? 'background: #313131' : ''">
        <v-btn color="white" text @click="handleBackStep()" v-if="windowIndex > 1 || formWindow > 1">
          <v-icon left>mdi-chevron-left</v-icon>
          Zurück
        </v-btn>
        <v-btn v-else @click="closeCreateView">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="windowIndex < 3" color="primary" depressed @click="handleNextStep()" :disabled="isNextDisabled">
          Weiter
          <v-icon right>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn v-else depressed color="primary" @click="handleSubmitPlan = true"> Speichern </v-btn>
      </div>
    </div>

    <v-dialog v-model="addWorkoutToSplit">
      <v-card dark>
        <v-card-title>Split hinzufügen</v-card-title>
        <v-card-text>
          <v-text-field label="Split Bezeichnung" filled outlined v-model="addNewSplitText"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-content-center">
          <v-btn color="primary" @click="saveWorkoutToSplit">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import api from "../../api"
import userSearch from "../../components/userSearch.vue"
import { mapState, mapActions, mapGetters } from "vuex"
import userService from "../../services/userService"
import workoutSplitEdit from "./WorkoutSplitEdit.vue"
import WorkoutSplitOverviewAndSubmit from "./WorkoutSplitOverviewAndSubmit.vue"

export default {
  name: "WorkoutCreate",
  components: {
    userSearch,
    workoutSplitEdit,
    WorkoutSplitOverviewAndSubmit,
  },
  data() {
    return {
      formWindow: 1,
      windowIndex: 1,
      handleNextStepForSplit: false,
      addNewSplitText: "",
      addWorkoutToSplit: false,
      handleSubmitPlan: false,
      splitItems: [
        {
          text: "Ganzkörper-Training",
          value: "fullBodySplit",
          info: "Jede Trainingseinheit trainiert den gesamten Körper.",
          workouts: [
            {
              title: "Ganzkörper",
              exercises: [],
              recommendedTags: [
                "Schienbein",
                "Rundmuskel",
                "Trapez",
                "Trizeps",
                "Latissimus",
                "Rückenstrecker",
                "Gesäss",
                "Beinbeuger",
                "Wade",
                "Vordere Schulter",
                "Scholle",
                "Seitliche Schulter",
                "Brust",
                "Hintere Schulter",
                "Gerader Bauch",
                "Bizeps",
                "Seitlicher Bauch",
                "Unterarm Unten",
                "Oberschenkel",
                "Nacken",
                "Adduktoren",
                "Unterarm Oben",
                "Herz-Kreislauf",
                "Dehnen",
                "Abduktoren",
              ],
            },
          ],
        },
        {
          text: "Oberkörper-/Unterkörper Split",
          value: "upperLowerSplit",
          info: "Ein Tag ist für den Oberkörper, der andere für den Unterkörper.",
          workouts: [
            {
              exercises: [],
              title: "Oberkörper",
              recommendedTags: [
                "Brust",
                "Vordere Schulter",
                "Seitliche Schulter",
                "Hintere Schulter",
                "Bizeps",
                "Trizeps",
                "Rückenstrecker",
                "Latissimus",
                "Trapez",
                "Unterarm Unten",
                "Unterarm Oben",
                "Gerader Bauch",
                "Seitlicher Bauch",
                "Nacken",
              ],
            },
            {
              exercises: [],
              title: "Unterkörper",
              recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle", "Gesäss", "Schienbein"],
            },
          ],
        },
        {
          text: "Push/Pull/Beine-Split",
          value: "pushPullLegSplit",
          info: "Drückende (Push), ziehende (Pull) Muskeln und Beine an separaten Tagen.",
          workouts: [
            {
              exercises: [],
              title: "Push",
              recommendedTags: ["Brust", "Vordere Schulter", "Trizeps", "Seitliche Schulter"],
            },
            {
              exercises: [],
              title: "Pull",
              recommendedTags: ["Rückenstrecker", "Latissimus", "Trapez", "Bizeps", "Hintere Schulter", "Unterarm Unten", "Unterarm Oben"],
            },
            {
              exercises: [],
              title: "Beine",
              recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle"],
            },
          ],
        },
        {
          text: "Bro-Split",
          value: "broSplit",
          info: "Jede Muskelgruppe hat einen eigenen Trainingstag.",
          workouts: [
            { title: "Brust", recommendedTags: ["Brust", "Seitlicher Bauch", "Gerader Bauch"], exercises: [] },
            { title: "Rücken", exercises: [], recommendedTags: ["Latissimus", "Rückenstrecker", "Trapez", "Schienbein"] },
            { title: "Schultern", exercises: [], recommendedTags: ["Vordere Schulter", "Seitliche Schulter", "Hintere Schulter", "Nacken"] },
            { title: "Beine", exercises: [], recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle"] },
            { title: "Arme", exercises: [], recommendedTags: ["Bizeps", "Trizeps", "Unterarm Unten", "Unterarm Oben"] },
          ],
        },
      ],
      dialog: true,
      noInstructorSnackbar: false,
      userService,
      form: {
        picture: null,
        title: "",
        duration: "",
        user_id: null,
        instructor_id: null,
        splits: { text: "", workouts: [] },
      },
    }
  },
  async created() {
    if (this.$route.params.conversion && this.planForConversion) {
      this.form = JSON.parse(JSON.stringify(this.planForConversion))
      this.windowIndex = 2
      this.resetPlanForConversion()
    } else if (this.isInEditMode) {
      if (this.planInEditMode && this.planInEditMode.form) {
        this.form = JSON.parse(JSON.stringify(this.planInEditMode.form))
        this.windowIndex = 2 // Im Bearbeitungsmodus direkt zum Editor
      } else {
        console.error("Konnte Trainingsplan im Bearbeitungsmodus nicht laden. Leite zurück zum Hub.")
        this.$router.push("/trainingshub")
      }
    } else {
      this.resetPlanInEditMode()
      if (this.workoutCreate && this.workoutCreate.form && this.workoutCreate.form.title) {
        if (confirm("Es wurden zwischengespeicherte Daten gefunden. Möchtest du diese laden?")) {
          this.form = this.workoutCreate.form
        } else {
          this.resetWorkoutCreateForm()
        }
      }
    }
  },
  computed: {
    ...mapGetters("runWorkoutStore", ["planForConversion"]),
    ...mapState("workingoutStore", ["workoutCreateExercises", "workoutCreate", "planInEditMode"]),
    progress() {
      if (this.windowIndex === 1) {
        return this.formWindow === 1 ? 25 : 50
      }
      if (this.windowIndex === 2) return 75
      if (this.windowIndex === 3) return 100
      return 0
    },
    isNextDisabled() {
      if (this.windowIndex === 1 && this.formWindow === 1) {
        return !this.form.user_id || !this.form.instructor_id
      }
      if (this.windowIndex === 1 && this.formWindow === 2) {
        return !this.form.splits || !this.form.splits.text
      }
      return false
    },
    formTitle() {
      switch (this.windowIndex) {
        case 1:
          return this.formWindow === 1 ? (this.isInEditMode ? "Plan bearbeiten" : "Plan erstellen") : "Wähle deinen Split"
        case 2:
          return "Workout zusammenstellen"
        case 3:
          return "Übersicht & Abschluss"
        default:
          return this.form.title || "Trainingsplan"
      }
    },
    isInEditMode() {
      return !!this.$route.params.id
    },
  },
  methods: {
    ...mapActions("runWorkoutStore", ["resetPlanForConversion"]),
    ...mapActions("workingoutStore", ["resetPlanInEditMode", "resetWorkoutCreateForm", "updateWorkoutCreateForm"]),

    handleNextStep() {
      if (this.isNextDisabled) return
      if (this.windowIndex === 2) {
        console.log("handleNextStepForSplit", this.handleNextStepForSplit)
        this.handleNextStepForSplit = true
      }
      if (this.windowIndex === 1) {
        if (this.formWindow === 1) {
          if (this.$refs.createForm && !this.$refs.createForm.validate()) {
            this.noInstructorSnackbar = true // Zeige Fehlermeldung
            return
          }
          this.noInstructorSnackbar = false
          this.formWindow = 2
        } else {
          this.windowIndex = 2
        }
      }
    },
    handleBackStep() {
      this.handleNextStepForSplit = false
      if (this.windowIndex === 3) {
        this.windowIndex = 2
      } else if (this.windowIndex === 2) {
        this.windowIndex = 1
        this.formWindow = 2
      } else if (this.windowIndex === 1) {
        if (this.formWindow === 2) {
          this.formWindow = 1
        }
      }
    },
    async updateWorkoutPlan() {
      if (this.form.ts && this.form.ts.key) this.form.ts = this.form.ts.value
      await api.workoutApi.updateTrainingsPlan(this.form._id, this.form)
      this.$toast.success("Trainingsplan erfolgreich aktualisiert")
      this.closeWorkoutForm(true)
    },
    selectSplit(split) {
      this.$set(this.form, "splits", JSON.parse(JSON.stringify(split)))
      this.$set(this.form, "title", split.text)
    },
    addNewSplit(newSplitName) {
      if (!this.form.splits.workouts) {
        this.$set(this.form.splits, "workouts", [])
      }
      this.form.splits.workouts.push({
        title: newSplitName,
        exercises: [],
        recommendedTags: [],
      })
    },
    saveWorkoutToSplit() {
      this.addNewSplit(this.addNewSplitText)
      this.addNewSplitText = ""
      this.addWorkoutToSplit = false
    },
    updateCustomer(id) {
      this.form.user_id = id
    },
    updateInstructor(id) {
      this.form.instructor_id = id
    },
    async createWorkoutPlan() {
      if (this.isInEditMode) {
        await this.updateWorkoutPlan()
      } else {
        await api.workoutApi.createTrainingsPlan(this.form)
        this.$toast.success("Trainingsplan erfolgreich erstellt")
        this.closeWorkoutForm(true)
      }
    },
    closeCreateView() {
      this.dialog = false
      this.$nextTick(() => {
        this.$router.push(this.isInEditMode ? "/trainingshub" : "/workouts")
      })
    },
    closeWorkoutForm(push) {
      this.resetWorkoutCreateForm()
      this.resetPlanInEditMode()
      this.$emit("reload-workouts")
      if (push) {
        this.closeCreateView()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-wizard-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #121212;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  color: white;
}

.mobile-wizard-progress {
  position: absolute;
  top: 88px;
  left: 0;
  width: 100%;
  z-index: 1;
  transition: all 0.4s ease-in-out;
}

.mobile-wizard-content {
  flex-grow: 1;
  overflow-y: auto;
  padding: 100px 24px 100px 24px;
  &.fullscreen-content {
    padding: 0;
    height: 100vh;
    overflow-y: hidden;
  }
}

.mobile-wizard-step {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mobile-wizard-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(to top, rgba(18, 18, 18, 1) 70%, rgba(18, 18, 18, 0));
  display: flex;
  align-items: center;
  z-index: 2;
}

/* --- HIER IST DIE ÄNDERUNG --- */
.choice-card {
  // Hellerer Hintergrund für besseren Kontrast
  background-color: #272727 !important;
  // Ein subtiler, aber sichtbarer Rand
  border: 1px solid #424242 !important;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    // Hellerer Hover-Effekt für klares Feedback
    background-color: #383838 !important;
    transform: translateY(-2px);
  }

  &--active {
    // Der Rand in der Primärfarbe hebt die Auswahl deutlich hervor
    border-color: var(--v-primary-base) !important;
    background-color: #272727 !important;
    .v-icon {
      color: var(--v-primary-base);
    }
  }
}
</style>
